import { CtInventoryLocation } from '@/models/interfaces/content-type'
import { ContentType } from '@/services/directr'
import ContentModule from '@/utils/store'

export const model = {
    id: {
      field: 'id',
      label: 'ID',
      validator: () => true,
      type: 'string',
      required: true
    },
    name: {
      field: 'name',
      label: 'Name',
      validator: () => true,
      type: 'string',
      required: true
    },
    catalogues: {
      field: 'catalogues',
      label: 'Reserved for Catalogues',
      validator: () => true,
      contentType: 'catalogue',
      type: 'link-list',
      required: false
    },
    storage_type: {
      field: 'storage_type',
      label: 'Storage Type',
      validator: () => true,
      contentType: 'storage_type',
      type: 'link',
      required: false
    },
    description: {
      field: 'description',
      label: 'Description',
      validator: () => true,
      type: 'string',
      required: false
    },
    capacity: {
      field: 'capacity',
      label: 'Capacity',
      validator: () => true,
      type: 'number',
      required: false
    },
    stock_item: {
      field: 'stock_item',
      label: 'Stock item stored',
      validator: () => true,
      contentType: 'stock',
      type: 'link',
      required: false
    }
    // count: {
    //   field: 'count',
    //   label: 'Items at Location',
    //   validator: () => true,
    //   type: 'number',
    //   default: 0,
    //   required: false
    // }
  }

// specify actions etc. for orders using Directr
const state = {}
const getters = {}
const mutations = {}
const actions = {}

export default ContentModule<CtInventoryLocation>(
  ContentType.InventoryLocation, 'Services/Directr',
  model,
  state,
  getters,
  mutations,
  actions)
